<template>
  <div>
    <loading
      :active.sync="active" 
      :can-cancel="false" 
      :is-full-page="fullPage || false"></loading>
  </div>
</template>
<script>
  //import Vue from "vue";
  import loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  export default {
    name:"Loading",
    props:['active', 'fullPage'],
    components:{loading},
    data() {
      return {
      }
    }
  }
</script>